export default [
  {
    path: 'server-builder/:id?',
    name: 'createServer',
    component: () => import('./ServerBuilder.vue'),
    children: [
      {
        path: 'choose-plan',
        name: 'choosePlan',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./ChoosePlan.vue'),
      },
      {
        path: 'choose-region',
        name: 'chooseRegion',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./ChooseRegion.vue'),
      },
      {
        path: 'core-features',
        name: 'coreFeatures',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./CoreFeatures.vue'),
      },
      {
        path: 'choose-add-ons',
        name: 'chooseAddOns',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./ChooseAddOns.vue'),
      },
      {
        path: 'choose-extras',
        name: 'chooseExtras',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./ChooseExtras.vue'),
      },
      {
        path: 'payment-details',
        name: 'paymentDetails',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./PaymentDetails.vue'),
      },
      {
        path: 'success',
        name: 'serverCreated',
        meta: {
          hideNavbar: true,
        },
        component: () => import('./Success.vue'),
      },
    ],
  },
];
